// components
import PenNib from "core/ReusableIcons/PenNib";
import PieceOfPie from "core/ReusableIcons/PieceOfPie";
import FigmaPluginIcon from "./FigmaPluginIcon";

import {
    FOR_ADOBE_PATH,
    FOR_FIGMA_PATH,
    FOR_OFFICE_PATH,
} from "static/assets/js/data/links";
import { trackHeaderFigmaClicked, trackHeaderIconsForAdobeClicked } from "core/trackEvent";

// styles
import colors from "core/colors";

export const promos = [
    {
        id: 1,
        title: `PowerPoint Icons`,
        text: `Find and edit icons without leaving PowerPoint or Office. <span class="faux-link">Try it out</span>`,
        href: FOR_OFFICE_PATH,
        target: `_self`,
        Icon: PieceOfPie,
        iconSize: 30,
    },
    {
        id: 2,
        title: `Icons for Figma`,
        text: `Easily drag and drop millions of free icons into Figma. <span class="faux-link">Get plugin</span>`,
        href: FOR_FIGMA_PATH,
        target: `_self`,
        Icon: FigmaPluginIcon,
        iconSize: 44,
        onClick() {
            trackHeaderFigmaClicked();
        },
    },
    {
        id: 3,
        title: `Icons for Adobe`,
        text: `Get the best icon library for InDesign, Illustrator, & Photoshop. <span class="faux-link">Get now</span>`,
        href: FOR_ADOBE_PATH,
        target: `_self`,
        Icon: PenNib,
        iconSize: 30,
        onClick() {
            trackHeaderIconsForAdobeClicked();
        },
    },
];

export const getLightDarkProps = isDarkMode => {
    let fontColor = colors.secondary.orca;
    let borderColor = colors.primary.scheifer;
    let borderHoverColor = colors.secondary.orca;
    let linkColor = colors.accent.lightMode.persian;
    let linkHoverColor = colors.accent.lightMode.pansy;

    if (isDarkMode) {
        fontColor = colors.primary.diamond;
        borderColor = colors.secondary.basalt;
        borderHoverColor = colors.primary.diamond;
        linkColor = colors.accent.darkMode.suenosBuenos;
        linkHoverColor = colors.accent.darkMode.surf;
    }

    return {
        fontColor,
        borderColor,
        borderHoverColor,
        linkColor,
        linkHoverColor,
    };
};
